export default {
    data: () => ({
        translations: {
            title: {
                el: "Ανταμοιβή με κάθε επίσκεψη στο κατάστημα",
                en: "Reward with presence in the store",
                it: "Ricompensa con la presenza in negozio"
            },
            info: {
                el: "Οι πελάτες κερδίζουν πόντους όταν επισκέπτονται το κατάστημά σας.",
                en: `Customers win points when they visit your store.`,
                it: "I clienti guadagnano punti quando visitano il tuo negozio."
            }
        }
    })
};
